module.exports = __webpack_public_path__ + "static/media/ua.72d8808c.svg";